export default __webpack_public_path__ + "static/assets/864f3052ab3f49c35b6871aec32c3a33.png";